import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

const NAME = '数据实体'

export default props => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_BD_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = async () => {
        const nodes = [...map.selectedNodes]

        const ns = nodes.filter(node => {
            const {bizNodeType, pkid, prjId, ruleType} = node.data

            return (
                pkid &&
                prjId === map.data.prjId &&
                'BDRULE' === bizNodeType &&
                'DE' === ruleType
            )
        })

        if (0 === ns.length) {
            await openModal(
                <Alert type="error">
                    请先选择{NAME}
                </Alert>
            )

            return
        }

        if (ns.length < nodes.length) {
            await openModal(
                <Alert type="warn">
                    选中的节点有些不是{NAME}，它们将被忽略
                </Alert>
            )
        }

        const {prjId, sVer} = map.data
        const {pkid: bdId} = map.root.data
        const deIds = []
        const deNames = []

        for (const n of ns) {
            const {pkid, ruleTitle} = n.data
            deIds.push(pkid)
            deNames.push(ruleTitle)
        }

        openWindow(
            '/Ai',

            {
                bizMap: {bdId, deIds},
                prjId,
                scene: 'GENERATE_DES',
                sVer,
                title: `${NAME}: ${deNames.join(', ')}`,
            }
        )
    }

    return {
        label: '示例数据',
        onClick,
        ...props,
    }
}
